// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"DeleteAppConfigButton_deleteIcon__1aunl"};